module.exports = __webpack_public_path__ + "/build/web/images/matching-pillows-options.f6c7b2b6d0f28ce092e18d4176573fda.png";


//////////////////
// WEBPACK FOOTER
// ./images/matching-pillows-options.png
// module id = 172
// module chunks = 13